document.addEventListener('DOMContentLoaded', function() {

    // Returns both business and private price elements from the price cell.
    function getPriceElements(priceTd) {
        if (!priceTd) {
            return { businessPrice: null, privatePrice: null };
        }
        const businessPrice = priceTd.querySelector('.js-business-user');
        const privatePrice = priceTd.querySelector('.js-private-user');
        return { businessPrice, privatePrice };
    }

    function getPriceAndCurrency(price, element){
        if (!price || !element) {
            return;
        }
        const text = price.textContent.trim();
        const currency = text.match(/[^\d.,]/g)?.join('') || '';
        const decimal = text.includes(',') ? ',' : '.';
        const currencyAtStart = text.match(/^[^\d]/);
        element.textContent = currencyAtStart
            ? currency + '0' + decimal + '00'
            : '0' + decimal + '00' + currency;
    }

    function getPriceAndCurrencyTotal(price, element, quantity){
        if (!price || !element || quantity == null) {
            return;
        }
        const priceText = price.textContent.trim();
        const priceNumber = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
        const currency = priceText.match(/[^\d.,]/g)?.join('') || '';
        const total = priceNumber * quantity;
        const decimal = priceText.includes(',') ? ',' : '.';
        const totalFormatted = total.toFixed(2).replace('.', decimal);
        const currencyAtStart = priceText.match(/^[^\d]/);
        element.textContent = currencyAtStart 
            ? currency + totalFormatted 
            : totalFormatted + currency;
    }

    const localization = window.FoxTheme && window.FoxTheme.localization;
    const countryCode = localization && localization.countryCode;
    const targetCountries = localization && localization.targetCountries;
    const isTargetCountry =
        Array.isArray(targetCountries) && targetCountries.includes(countryCode);
    
    //Filters variant rows
    document.querySelectorAll('.search-variant-input').forEach(input => {
        input.addEventListener('input', function() {
            const tableContainer = this.closest('.variant-table-container');

            const filter = this.value.toLowerCase();
            const rows = tableContainer.querySelectorAll('.variant-row');
            rows.forEach(row => {
                const td = row.querySelector('td:first-child');
                const title = td.childNodes[0].nodeValue.trim().toLowerCase();
                const qtyEl = row.querySelector('.variant-quantity');
                const totalEl = row.querySelector('.variant-total');
                const priceTd = row.querySelector('.variant-price');
                const { businessPrice, privatePrice } = getPriceElements(priceTd);
                
                
                if(title.includes(filter)) {
                    row.style.display = '';
                } else {
                    row.style.display = 'none';
                }
            });
        });
    });
    
    // Handles plus/minus quantity buttons and updates variant total price.
    document.querySelectorAll('.variant-row').forEach(row => {
        const minusBtn = row.querySelector('.variant-quantity-minus');
        const plusBtn  = row.querySelector('.variant-quantity-plus');
        const qtyEl    = row.querySelector('.variant-quantity');
        const totalEl  = row.querySelector('.variant-total');

        const stepInput = row.querySelector('input[type="number"]');
        const step = parseInt(stepInput.dataset.step, 10) || 1;
        const inventory = parseInt(stepInput.dataset.inventoryQuantity, 10) || 0;
        const alwaysInStock = stepInput.dataset.alwaysInStock === 'true';

        function updatePlusState() {
            const current = parseInt(qtyEl.textContent, 10);

            if (!alwaysInStock && current + step > inventory) {
                plusBtn.classList.add('increase-disabled');
            } else {
                plusBtn.classList.remove('increase-disabled');
            }
        }

        function updateTotal() {
            const priceTd = row.querySelector('.variant-price');
            const { businessPrice, privatePrice } = getPriceElements(priceTd);

            const businessTotalEl = totalEl.querySelector('.js-business-user');
            const privateTotalEl = totalEl.querySelector('.js-private-user');

            if (!businessPrice || !privatePrice) return;

            const qty = parseInt(qtyEl.textContent, 10);

            // Calculate business total
            getPriceAndCurrencyTotal(businessPrice, businessTotalEl, qty);

            // Calculate private total
            getPriceAndCurrencyTotal(privatePrice, privateTotalEl, qty);

            const tableContainer = row.closest('.variant-table-container');
            updateAllVariantsTotal(tableContainer);
            updateTotalItems(tableContainer);

            updatePlusState();
        }

        minusBtn.addEventListener('click', () => {
            let current = parseInt(qtyEl.textContent, 10);
            current = Math.max(0, current - step);
            qtyEl.textContent = current;
            updateTotal();
        });

        plusBtn.addEventListener('click', () => {
            if (plusBtn.classList.contains('increase-disabled')) return;

            let current = parseInt(qtyEl.textContent, 10);
            current += step;
            qtyEl.textContent = current;
            updateTotal();
        });

        // initial check
        updatePlusState();
    });

    
    function updateAllVariantsTotal(tableContainer) {
        const totalEls = tableContainer.querySelectorAll('.variant-total');
        let sumBusiness = 0;
        let sumPrivate = 0;
        let businessCurrency = '';
        let privateCurrency = '';
        
        totalEls.forEach(el => {
            
            const businessSpan = el.querySelector('.js-business-user');
            const privateSpan = el.querySelector('.js-private-user');
            
            if(businessSpan) {
                const text = businessSpan.textContent.trim();
                const num = parseFloat(text.replace(/[^0-9.,]/g, '').replace(',', '.'));
                sumBusiness += num;
                if(!businessCurrency) {
                    businessCurrency = text.match(/[^\d.,]/g)?.join('') || '';
                }
            }
            
            if(privateSpan) {
                const text = privateSpan.textContent.trim();
                const num = parseFloat(text.replace(/[^0-9.,]/g, '').replace(',', '.'));
                sumPrivate += num;
                if(!privateCurrency) {
                    privateCurrency = text.match(/[^\d.,]/g)?.join('') || '';
                }
            }
        });
        
        if(totalEls.length > 0) {
            const decimal = totalEls[0].textContent.includes(',') ? ',' : '.';
            const sumBusinessFormatted = sumBusiness.toFixed(2).replace('.', decimal);
            const sumPrivateFormatted = sumPrivate.toFixed(2).replace('.', decimal);

            const footerBusinessEl = tableContainer.querySelector('span.all-variants-total.js-business-user');
            const footerPrivateEl = tableContainer.querySelector('span.all-variants-total.js-private-user');
            
            const firstBusinessTotal = tableContainer.querySelector('.variant-row:not([style*="display: none"]) .variant-total .js-business-user');
            const firstPrivateTotal = tableContainer.querySelector('.variant-row:not([style*="display: none"]) .variant-total .js-private-user');
            
            if(footerBusinessEl && firstBusinessTotal) {
                const businessCurrencyAtStart = firstBusinessTotal.textContent.trim().match(/^[^\d]/);
                footerBusinessEl.textContent = businessCurrencyAtStart 
                    ? businessCurrency + sumBusinessFormatted 
                    : sumBusinessFormatted + businessCurrency;
            }
            
            if(footerPrivateEl && firstPrivateTotal) {
                const privateCurrencyAtStart = firstPrivateTotal.textContent.trim().match(/^[^\d]/);
                footerPrivateEl.textContent = privateCurrencyAtStart 
                    ? privateCurrency + sumPrivateFormatted 
                    : sumPrivateFormatted + privateCurrency;
            }
        }
    }
    
    function updateTotalItems(tableContainer) {
        const qtyEls = tableContainer.querySelectorAll('.variant-quantity');
        let totalItems = 0;
        qtyEls.forEach(el => {
            totalItems += parseInt(el.textContent, 10);
        });
        tableContainer.querySelector('.all-variants-total-items span').textContent = totalItems;
    }
    
    document.querySelectorAll('.add-all-to-cart').forEach(button => {
        button.addEventListener('click', async function() {
            const tableContainer = this.closest('.variant-table-container');
            const items = [];
            tableContainer.querySelectorAll('.variant-row').forEach(row => {
                const qtyEl = row.querySelector('.variant-quantity');
                const quantity = parseInt(qtyEl.textContent, 10);
                if(quantity > 0) {
                    const hiddenInput = row.querySelector('input[type="number"]');
                    const variantId = hiddenInput.getAttribute('variant_id');

                    const itemPayload = {
                        id: variantId,
                        quantity: quantity
                    };

                    items.push(itemPayload);
                }
            });
            
            if(items.length === 0) {
                return;
            }
            
            button.disabled = true;
            
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ items: items })
                });
                
                if (!response.ok) {
                    throw new Error('Failed to add items to cart');
                }
                
                const result = await response.json();
                const cartResponse = await fetch('/cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                
                const cartData = await cartResponse.json();
                document.dispatchEvent(new CustomEvent('cart:updated', { 
                    detail: { cart: cartData }
                }));
                document.dispatchEvent(new CustomEvent('cart:refresh', { 
                    detail: { open: true }
                }));
                
                tableContainer.querySelectorAll('.variant-row').forEach(row => {
                    const qtyEl = row.querySelector('.variant-quantity');
                    qtyEl.textContent = '0';
                    
                    const totalEl = row.querySelector('.variant-total');
                    const priceTd = row.querySelector('.variant-price');
                    const { businessPrice, privatePrice } = getPriceElements(priceTd);
                    
                    const businessTotalEl = totalEl.querySelector('.js-business-user');
                    const privateTotalEl = totalEl.querySelector('.js-private-user');
                    
                    if(businessPrice && businessTotalEl) {
                        getPriceAndCurrency(businessPrice, businessTotalEl);
                    }
                    
                    if(privatePrice && privateTotalEl) {
                        getPriceAndCurrency(privatePrice, privateTotalEl);
                    }
                    
                    const hiddenInput = row.querySelector('input[type="number"]');
                    hiddenInput.value = '0';
                });
                
                updateAllVariantsTotal(tableContainer);
                updateTotalItems(tableContainer);

                const drawerContent = document.querySelector('.drawer__content');
                let sectionId = null;

                if (drawerContent) {
                    sectionId = drawerContent.getAttribute('id');
                }

                const sectionsRes = await fetch(`/?sections=${sectionId}`);
                const sectionsJson = await sectionsRes.json();

                cartData.sections = sectionsJson;
                
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
                    cart: cartData 
                });
            } catch (error) {
                console.log("Error:" + error);
            } finally {
                button.disabled = false;
            }
        });
    });
});